import { FormDataConsumer, SelectInput, SelectInputProps, TextInput } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { useContentTypeContext } from '..';
import BlocksInput from '../../BlocksInput';
import LinkInput from '../../LinkInput';
import Blocks from './Blocks';

export interface ContentTypeDataProps extends SelectInputProps {
  source: string,
}

const ContentTypeData = ({ ...props }: ContentTypeDataProps) => {
  const { source } = props;
  const sourceData = `${source}_data`;
  const sourceValue = useWatch({ name: source })
  const { recordOptions, programOptions } = useContentTypeContext();

  switch (sourceValue) {
    case "blocks": return <Blocks source={sourceData}></Blocks>;
    case "redirect": return <LinkInput source={sourceData}></LinkInput>;
    case "records": return <SelectInput source={sourceData} choices={recordOptions} fullWidth />;
    case "program": return <>
      <SelectInput source={`${sourceData}.id`} choices={programOptions} fullWidth />
      <FormDataConsumer>{({ formData, ...rest }) => {
        console.log(
          formData,
          // rest, 
          // programOptions,
          formData[sourceData].id,
          programOptions.filter(programOption => programOption.id === formData[sourceData].id),
          programOptions.filter(programOption => programOption.id === formData[sourceData].id)[0].blocks?.length
        );
        const programOption = programOptions.filter(programOption => programOption.id === formData[sourceData].id);
        if (programOption && 1===programOption.length && programOption[0].blocks && programOption[0].blocks.length > 0) {
          return <BlocksInput source={`${sourceData}.config`} hideLabel={true} config={programOption[0].blocks}></BlocksInput>
        } else {
          return null
        }
      }}</FormDataConsumer>
    </>;
    case "frontend_effect": return <TextInput source={sourceData} fullWidth multiline={true} minRows={3} maxRows={5} />;
    default: return null;
  }
}

ContentTypeData.defaultProps = {
}

export default ContentTypeData;
